import { useState } from 'react'
import { Typography } from '@mui/material'
import { useSelector } from 'src/utils/store'
import { capitalizeString } from 'src/utils/capitalize'
import { useDispatch } from 'react-redux'
import { actions } from '../../../../RestockingState'
import { useHistory } from 'react-router-dom'
import TextLabel from '../TextLabel/TextLabel'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import ExitActionsModal from '../ExitActionsModal/ExitActionsModal'
import * as S from './UserIdentifier.styles'

interface UserIdentifierProps {
  idPage: number | undefined
}

const UserIdentifier: React.FC<UserIdentifierProps> = ({ idPage }) => {
  const [showExitActionsModal, setShowExitActionsModal] = useState(false)
  const { user } = useSelector((state) => state.restocking)
  const dispatch = useDispatch()
  const history = useHistory()

  const closeExitActionsModal = () => setShowExitActionsModal(false)

  const navigateToProductCollect = () => history.push('/restocking/webapp/badge')

  const onSuccess = () => navigateToProductCollect()

  const logoff = () => {
    dispatch(actions.clearState())
    onSuccess()
  }

  return (
    <S.Container>
      <Typography>Usuário:</Typography>
      <TextLabel>
        <Typography>{capitalizeString(user.user)}</Typography>
      </TextLabel>
      <CancelOutlinedIcon
        color='error'
        onClick={() => setShowExitActionsModal(true)}
        sx={{ cursor: 'pointer' }}
        data-testid='exit-actions-button-test-id'
      />
      <ExitActionsModal
        show={showExitActionsModal}
        idPage={idPage}
        title='Selecione uma operação'
        dataTestId='exit-actions-modal-test-id'
        onClose={closeExitActionsModal}
        setShowExitActionsModal={setShowExitActionsModal}
        logoffAction={logoff}
        onSuccess={onSuccess}
      />
    </S.Container>
  )
}

export default UserIdentifier
